import React, { Component } from 'react';

export default class TabMenuButton extends Component {
    constructor(props) {
        super(props);
    }

    onSelected() {
        if (this.props.selected) return;
        let { onSelected } = this.props;
        if (onSelected == null) return;
        onSelected(this.props.type, this.props.name);
    }

    render() {

        let { type, name } = this.props;

        return (
            <div className='flex flex-col flex-auto justify-center items-center' onClick={e => { this.onSelected() }}>
                <div className={`flex flex-auto justify-center items-center pt-3 pb-2 ${this.props.selected ? 'text-gray-900' : 'text-gray-400'}`}>
                    {name}
                </div>
                <div className={`${this.props.selected ? 'bg-txt-selected' : ''} w-6 h-1`}></div>
            </div>
        );
    }
}